import { render, staticRenderFns } from "./BMWTerms.vue?vue&type=template&id=7ac50e68"
import script from "./BMWTerms.vue?vue&type=script&lang=js"
export * from "./BMWTerms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports